import React from "react";
import TagsList from "./tagsList";

/**
 * Componente para la administración de tags de recursos
 * @author Jhoan López <jhoanlt19@gmail.com>
 */
class ResourcesTags extends React.Component {
  render() {
    return <TagsList />;
  }
}

export default ResourcesTags;



// WEBPACK FOOTER //
// ./src/components/tags-manager/resources-tags/index.js